import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../hooks/useAppSelector';
import { selectAuthBootstrapComplete, selectIsAuthenticated } from '../../store/features/auth';
import { tokenStore } from '../../services/tokenStore';
import { AuthGateFallback } from './AuthGateFallback';

type SetPasswordRouteProps = {
  children: React.ReactNode;
};

/**
 * Allows set-password for guests with a temporary checkout JWT or signed-in users.
 */
export function SetPasswordRoute({ children }: SetPasswordRouteProps) {
  const location = useLocation();
  const bootstrapComplete = useAppSelector(selectAuthBootstrapComplete);
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const hasAccessToken = Boolean(tokenStore.getAccessToken());

  if (!bootstrapComplete) {
    return <AuthGateFallback message="Checking your session..." />;
  }

  if (!isAuthenticated && !hasAccessToken) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: location,
          message:
            'Sign in or use the secure link from your email to set your password.',
        }}
      />
    );
  }

  return <>{children}</>;
}
